import { SFCategory } from "@robe/core";
import { StringifyFunc } from "./hooks";
import { isPlainObject } from "is-plain-object";
import { Node, Text } from "slate";

export const isRichtextPlainText = (node: Node): node is Text => isPlainObject(node) && typeof (node as any).text === "string";

interface ResolveSFCategoryLabelParams {
  category: SFCategory;
  stringifyFunc: StringifyFunc;
}

export const resolveSFCategoryLabel = ({ category, stringifyFunc }: ResolveSFCategoryLabelParams) => {
  let label = category?.name ?? "";

  if (category.localeName) {
    const localeName = stringifyFunc(category.localeName);
    localeName === "" ? category.localeName?.en && (label = category.localeName?.en) : (label = localeName);
  }

  return label;
};
